import { Pipe, PipeTransform } from '@angular/core';
import { HotLiveStatusEnum } from 'src/app/recruiting/candidates/new-profile/models/candidate-hotlive-status.enum';

@Pipe({ name: 'releaseTooltip', standalone: true })
export class ReleaseTooltipPipe implements PipeTransform {
    transform(value: HotLiveStatusEnum): string {
        return value === HotLiveStatusEnum.Live ? 'Remove from Live List before releasing' : 'Release candidate';
    }
}
